import * as ActionTypes from '../constants/actiontypes/account';
import * as Loadings from '../constants/loadings/account';
import User from '../constants/models/user';
import * as R from 'ramda';
import SbxApplication from '../constants/models/sxbApplication';
// import { USER_INSTANCE, APPS_INSTANCE } from '../constants/utils/global'; // use this when in mock

const UserReducer = (state = {
    isLoading: [],
    invalidPassword: undefined,
    user: undefined,
    applications: undefined
}, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_USER_REQUEST:
            return {
                ...state,
                isLoading: [...state.isLoading, Loadings.FETCHING_USER],
                user: { ...new User(action.data) }
            };
        case ActionTypes.FETCH_USER_SUCCESS:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.FETCHING_USER),
                user: { ...new User(action.data) }
            };
        case ActionTypes.UPDATE_USER_REQUEST:
            return {
                isLoading: [...state.isLoading, Loadings.UPDATE_USER],
                ...state
            };
        case ActionTypes.UPDATE_USER_SUCCESS:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.UPDATE_USER),
                user: { ...new User(action.data) }
            };
        case ActionTypes.UPDATE_USER_FAILURE:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.UPDATE_USER)
            };
        case ActionTypes.UPDATE_PASSWORD_REQUEST:
            return {
                ...state,
                isLoading: [...state.isLoading, Loadings.UPDATE_PASSWORD]
            };
        case ActionTypes.UPDATE_PASSWORD_SUCCESS:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.UPDATE_PASSWORD),
                invalidPassword: action.data.isValid ? undefined : action.data.statusName.replace(/:/gi, ""),
                user: action.data.isValid ? { ...state.user, lastPasswordChangedDate: new Date() } : state.user
            };
        case ActionTypes.UPDATE_PASSWORD_FAILURE:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.UPDATE_PASSWORD)
            };
        case ActionTypes.DELETE_ACCOUNT_REQUEST:
            return {
                ...state,
                isLoading: [...state.isLoading, Loadings.DELETING_ACCOUNT],
            };
        case ActionTypes.DELETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.DELETING_ACCOUNT),
            };
        case ActionTypes.DELETE_ACCOUNT_FAILURE:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.DELETING_ACCOUNT),
            };
        case ActionTypes.FETCH_APPLICATIONS_REQUEST:
            return {
                ...state,
                isLoading: [...state.isLoading, Loadings.FETCH_APPLICATIONS],
            };
        case ActionTypes.FETCH_APPLICATIONS_SUCCESS:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.FETCH_APPLICATIONS),
                applications: action.data.items.map(ap => new SbxApplication(ap))
            };
        case ActionTypes.FETCH_APPLICATIONS_FAILURE:
            return {
                ...state,
                isLoading: [...state.isLoading.filter(item => item !== Loadings.FETCH_APPLICATIONS)],
            };
        case ActionTypes.UPLOAD_PROFILE_IMAGE_REQUEST:
        case ActionTypes.DELETE_PROFILE_IMAGE_REQUEST:
            return {
                ...state,
                isLoading: [...state.isLoading, Loadings.UPDATE_PICTURE],
            };
        case ActionTypes.UPLOAD_PROFILE_IMAGE_SUCCESS:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.UPDATE_PICTURE),
                user: !R.isNil(state.user) ? { ...state.user, pictureUrl: action.data.pictureUrl } : undefined
            };
        case ActionTypes.UPLOAD_PROFILE_IMAGE_FAILURE:
        case ActionTypes.DELETE_PROFILE_IMAGE_FAILURE:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.UPDATE_PICTURE)
            };
        case ActionTypes.DELETE_PROFILE_IMAGE_SUCCESS:
            return {
                ...state,
                isLoading: state.isLoading.filter(item => item !== Loadings.UPDATE_PICTURE),
                user: !R.isNil(state.user) ? { ...state.user, pictureUrl: undefined } : undefined
            };
        default:
            return state;
    }
};
export default UserReducer;